import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus, AccountInfo } from '@azure/msal-browser';
import { Navigate } from 'react-router-dom';
import { isE2EMockAuth } from '../../utils/e2eMockAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (isE2EMockAuth()) {
    return <>{children}</>;
  }

  React.useEffect(() => {
    // If an account exists but none is active, set it
    const active = instance.getActiveAccount();
    const accounts = instance.getAllAccounts();
    if (!active && accounts.length > 0) {
      instance.setActiveAccount(accounts[0] as AccountInfo);
    }
  }, [instance]);

  const hasAccount = !!instance.getActiveAccount() || instance.getAllAccounts().length > 0;

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="loading-spinner w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-gray-600">Authenticating...</p>
        </div>
      </div>
    );
  }

  if (!(isAuthenticated || hasAccount)) {
    return <Navigate to="/welcome" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
